import { render, staticRenderFns } from "./numbers-slider.vue?vue&type=template&id=a88d0ad0&scoped=true"
import script from "./numbers-slider.vue?vue&type=script&lang=js"
export * from "./numbers-slider.vue?vue&type=script&lang=js"
import style0 from "./numbers-slider.vue?vue&type=style&index=0&id=a88d0ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88d0ad0",
  null
  
)

export default component.exports